import React, { useEffect, useRef, useState } from "react";

//OUTSIDE COMPONENTS
import { Moment } from 'moment';
import moment from 'moment';
import 'moment/locale/pt';
import 'moment/locale/en-gb'
import Chartjs from "chart.js";
import 'hammerjs';
import { PluginServiceRegistrationOptions, ChartColor, Scriptable, ChartPoint, ChartTooltipCallback, ChartLegendLabelItem, ChartData } from "chart.js";
import zoom from 'chartjs-plugin-zoom';
import { LineChartProps as LineProps } from "./LineChart"
import variables from "../../../assets/bootstrap/scss/_variables.scss"


interface BarChartDataProps {
	backgroundColor?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	borderColor?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	borderWidth?: number,
	data?: Array<number | null | undefined> | ChartPoint[],
	hidden?: boolean | undefined,
	label?: string,
	fontSize?: number
}
export interface BarChartProps extends LineProps {
	chartLabels?: any, /* Array<string | TFunctionResult | undefined | string[] | number | number[] | Date | Date[] | Moment | Moment[]> */

	xStacked?: boolean,
	yStacked?: boolean,

	sixthLabelData?: string,
	sixthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	sixthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	sixthData?: Array<number | null | undefined> | ChartPoint[];

	seventhBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	seventhBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	seventhData?: Array<number | null | undefined> | ChartPoint[];
	seventhHiddenData?: boolean | undefined,
	seventhLabelData?: string,

	eighthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eighthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eighthData?: Array<number | null | undefined> | ChartPoint[];
	eighthHiddenData?: boolean | undefined,
	eighthLabelData?: string,

	ninthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	ninthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	ninthData?: Array<number | null | undefined> | ChartPoint[];
	ninthHiddenData?: boolean | undefined,
	ninthLabelData?: string,

	tenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	tenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	tenthData?: Array<number | null | undefined> | ChartPoint[];
	tenthHiddenData?: boolean | undefined,
	tenthLabelData?: string,

	eleventhBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eleventhBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eleventhData?: Array<number | null | undefined> | ChartPoint[];
	eleventhHiddenData?: boolean | undefined,
	eleventhLabelData?: string,

	twelfthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	twelfthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	twelfthData?: Array<number | null | undefined> | ChartPoint[];
	twelfthHiddenData?: boolean | undefined,
	twelfthLabelData?: string,

	thirteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	thirteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	thirteenthData?: Array<number | null | undefined> | ChartPoint[];
	thirteenthHiddenData?: boolean | undefined,
	thirteenthLabelData?: string,

	fourteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	fourteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	fourteenthData?: Array<number | null | undefined> | ChartPoint[];
	fourteenthHiddenData?: boolean | undefined,
	fourteenthLabelData?: string,

	fifteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	fifteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	fifteenthData?: Array<number | null | undefined> | ChartPoint[];
	fifteenthHiddenData?: boolean | undefined,
	fifteenthLabelData?: string,

	sixteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	sixteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	sixteenthData?: Array<number | null | undefined> | ChartPoint[];
	sixteenthHiddenData?: boolean | undefined,
	sixteenthLabelData?: string,

	seventeenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	seventeenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	seventeenthData?: Array<number | null | undefined> | ChartPoint[];
	seventeenthHiddenData?: boolean | undefined,
	seventeenthLabelData?: string,

	eighteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eighteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	eighteenthData?: Array<number | null | undefined> | ChartPoint[];
	eighteenthHiddenData?: boolean | undefined,
	eighteenthLabelData?: string,

	nineteenthBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	nineteenthBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	nineteenthData?: Array<number | null | undefined> | ChartPoint[];
	nineteenthHiddenData?: boolean | undefined,
	nineteenthLabelData?: string,

	twentiethBackgroundColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	twentiethBorderColorData?: ChartColor | ChartColor[] | Scriptable<ChartColor>,
	twentiethData?: Array<number | null | undefined> | ChartPoint[];
	twentiethHiddenData?: boolean | undefined,
	twentiethLabelData?: string,

	yAxesStepSize?: number
	hidden?: boolean

	firstHiddenData?: boolean | undefined,
	secondHiddenData?: boolean | undefined,
	thirdHiddenData?: boolean | undefined,
	fourthHiddenData?: boolean | undefined,
	fifthHiddenData?: boolean | undefined,
	sixthHiddenData?: boolean | undefined,

	data?: BarChartDataProps[];
}

const BarChart = ({
	pluginOfChart,
	/* xAxisData,  */
	chartLabels,

	xStacked,
	yStacked,
	legendDisplay,
	dateFrom,
	dateTo,
	tooltipCallback,
	yAxesTicksMin,
	yAxesTicksMax,
	yAxesTicksCallback = (value, position, array) => {
		return value as any
	},
	/* beforeInit, */
	yAxesStepSize = 1,
	hidden = false,
	data = [{ backgroundColor: "#F06292", borderColor: "#F06292", borderWidth: 1 }]
}: BarChartProps) => {
	// initialise with null, but tell TypeScript we are looking for an HTMLCanvasElement
	const chartContainer = useRef<HTMLCanvasElement>(null);
	const [width, setWidth] = useState(window.innerWidth);
	const [chartInstance, setChartInstance] = useState<Chart | null>();
	const { gridBreakLg, gridBreakMd, gridBreakSm } = variables;
	//const [zoomOn, setZoomOn] = useState(false);

	const updateWindowDimensions = () => {
		setWidth(window.innerWidth)
	}

	const chartConfig = {
		type: "bar",
		data: {
			//x: xAxisData as number | string | Date | Moment,
			labels: chartLabels as /* Array<string | TFunctionResult | undefined | string[] | number | number[] | Date | Date[] | Moment | Moment[]>  */any,
			datasets: data
		},
		options: {
			legend: {

				position: (width >= parseInt(gridBreakMd)) ? "right" : "bottom" as "bottom" | "left" | "right" | "top" | "chartArea" | undefined,

				labels: {
					fontColor: "#494949",
					fontSize: 13,
					padding: 15,
					boxWidth: 12.5,
					filter: function (item: ChartLegendLabelItem, chart: ChartData) {
						if (item.text != undefined) {
							return !item.text.includes('null');
						}
					}
				}
			},
			tooltips: {
				enabled: true,
				mode: 'index' as "label" | "index" | "x" | "point" | "nearest" | "single" | "x-axis" | "dataset" | "y" | undefined,
				callbacks: tooltipCallback as ChartTooltipCallback,
				footerFontStyle: 'normal'
			},
			pan: {
				enabled: true,
				mode: 'x'
			},
			zoom: {
				enabled: true /* zoomOn */,
				mode: 'x'
			},
			responsive: true,
			maintainAspectRatio: false, // Add to prevent default behaviour of full-width/height
			events: ['click'],
			scales: {
				yAxes: [{
					stacked: yStacked as boolean,
					ticks: {
						beginAtZero: true,
						fontSize: 10,
						min: yAxesTicksMin as number,//-0.1,
						max: yAxesTicksMax as number,
						stepSize: yAxesStepSize,
						callback: yAxesTicksCallback as (
							value: string | number,
							index: number,
							values: number[] | string[]
						) => string | number | null | undefined
					},
					scaleLabel: {
						show: true,
						labelString: 'Value'
					}
				}],

				xAxes: [{
					stacked: xStacked as boolean,
					offset: true,
					gridLines: {
						display: true
					},
					ticks: {
						beginAtZero: true,
						fontSize: 10,
						callback: function (value: string) {
							if (value.length > 15) {
								return value.slice(0, 15) + "..."
							} else {
								return value
							}
						}
					},
				}]
			},
			/* scales: {
					x: {
						stacked: true
					},
					y: {
						stacked: true
					},
					xAxes: [{
					type: 'time',
					ticks: {
						autoSkip: true,
						maxTicksLimit: 20
					},
					time: {
						parse: 'DD/MM/YYYY',
						tooltipFormat: 'DD MMM',
						displayFormats: {
						'day': 'DD MMM',
						'minute': 'DD MMM',
							'hour': 'DD MMM',
						},
							unit: 'day' as "day" | "millisecond" | "second" | "minute" | "hour" | "week" | "month" | "quarter" | "year" | undefined,
							min:  dateFrom as string,
							max:  dateTo as string
						}
					}],

				yAxes: [{
				ticks: {
						min: yAxesTicksMin as number,//-0.1,
						max: yAxesTicksMax as number,
						stepSize: yAxesStepSize,
						callback: yAxesTicksCallback as (
							value: string | number,
							index: number,
							values: number[] | string[]
						) => string | number | null | undefined
					},
					scaleLabel: {
						show: true,
						labelString: 'Value'
					}
				}]
			},  */
		},

		plugins: pluginOfChart as PluginServiceRegistrationOptions[],
	};

	useEffect(() => {
		let language: string;
		language = localStorage.getItem("i18nextLng") || "pt";
		if (language.length > 2) {
			language = language.substr(0, 2).toUpperCase();
		}
		moment.locale(language)

		Chartjs.plugins.register(zoom);
		updateWindowDimensions();
		// strict null checks need us to check if chartContainer and current exist.
		// but once current exists, it is of type HTMLCanvasElement
		if (chartContainer && chartContainer.current) {
			// if the chart is not undefined (e.g. it has been created)
			// then destory the old one so we can create a new one later
			if (chartInstance) {
				chartInstance.destroy();
			}

			const newChartInstance = new Chartjs(chartContainer.current, chartConfig);
			setChartInstance(newChartInstance);
		}
	}, [dateTo, dateFrom, data]);

	return (
		<React.Fragment>
			<canvas hidden={hidden} ref={chartContainer} className="chart" />
		</React.Fragment>
	);
};

export default BarChart;
